import '../scss/style.scss';
import './modules/timeline';
import './modules/menu-toggle';
import './modules/houdini';
import './modules/scrollmagic';
import initFoundation from './modules/foundation';

initFoundation();
